module.exports = __webpack_public_path__ + "static/media/arrow-rigth-green-line.5510a84e.svg";